import {Offer, offerDecoder} from './Offer'
import {
    InquiryStatusChangeWithUsers,
    inquiryStatusChangeWithUsersDecoder
} from './InquiryStatusChangeWithUsers'
import {Inquiry, inquiryDecoder} from './Inquiry'
import {Decoder, object, field} from 'json-bouncer'

export interface OfferWithDetails {
    readonly offer: Offer
    readonly inquiryStatusChangeWithUsers: InquiryStatusChangeWithUsers
    readonly inquiry: Inquiry
}

export function offerWithDetailsDecoder(): Decoder<OfferWithDetails> {
    return object({
        offer: field('offer', offerDecoder()),
        inquiryStatusChangeWithUsers: field('inquiryStatusChangeWithUsers', inquiryStatusChangeWithUsersDecoder()),
        inquiry: field('inquiry', inquiryDecoder())
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/OfferWithDetails.ts